import './check';

SNI.Application.addService('utility', function(application) {

  let check = application.getService('check').new();

  let counter = 0;

  let nowDate = Date.now || function() {
    return new Date().getTime();
  };

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : nowDate();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = nowDate();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = nowDate() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = nowDate();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  }

  function deepMerge(target, src) {
    let array = Array.isArray(src);
    let dst = array && [] || {};

    if (array) {
      target = target || [];
      dst = dst.concat(target);
      src.forEach(function(e, i) {
        if (typeof dst[i] === 'undefined') {
          dst[i] = e;
        } else if (typeof e === 'object') {
          dst[i] = deepMerge(target[i], e);
        } else {
          if (target.indexOf(e) === -1) {
            dst.push(e);
          }
        }
      });
    } else {
      if (target && typeof target === 'object') {
        Object.keys(target).forEach(function(key) {
          dst[key] = target[key];
        });
      }
      Object.keys(src).forEach(function(key) {
        if (typeof src[key] !== 'object' || !src[key]) {
          dst[key] = src[key];
        } else {
          if (!target[key]) {
            dst[key] = src[key];
          } else {
            dst[key] = deepMerge(target[key], src[key]);
          }
        }
      });
    }

    return dst;
  }

  function toTitleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  function bindClickOutside($el, namespace, fn, exception, eventList = ['click', 'touchstart']) {
    let events = eventList.map(e => `${e}.${namespace}`).join(' ');
    setTimeout(function() {
      $(document).on(events, function(e) {
        let isOutsideMenu = ($(e.target) !== $el && !$.contains($el[0], e.target));
        if (isOutsideMenu && (!exception || (e.target !== exception))) {
          e.preventDefault();
          fn(e);
        }
      });
      //allow escape key to call 'fn'
      $(document).on(`keyup.${namespace}`, function(e) {
        e.which === 27 && fn(e);
      });
    }, 1);
  }

  function unbindClickOutside(namespace) {
    $(document).off(`click.${namespace}`);
    $(document).off(`touchstart.${namespace}`);
    $(document).off(`keyup.${namespace}`);
  }

  function getMainHostname(originalHost = window.location.hostname) {

    // Don't mutate original hostname
    let host = originalHost;

    if (check.isFriendlyHost(host)) {

      //special case for golden-www.brand.com
      let splitHost = host.split('.');
      if (splitHost.length === 3 && splitHost[0] === 'golden-www') {
        return host;
      }

      // If golden subdomain is used, switch to main golden domain
      if (splitHost[0].includes('golden-')) {
        host = host.replace(/^[^\.]*/g, 'golden-www');
      } else {
        host = host.replace(/^[^\.]*/g, 'www');
      }

    }
    return host;
  }

  // Takes a dev environment host and returns a prod env (www or photos)
  function getProdUrl(host) {
    // Format expected: [www|photos].hgtv.dev-environment.sni.*
    let replaced = (host||'').replace(/((photos|www)\.)([a-z]+\..+sni\.)/,'$1');
    return replaced;
  }

  function stdTimezoneOffset(date) {
    const jan = new Date(date.getFullYear(), 0, 1),
          jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  function isDaylightSavings(date) {
    return date.getTimezoneOffset() < stdTimezoneOffset(date);
  }

  function getZone(dateTime) {
    const dst = isDaylightSavings(dateTime);
    let zone = 'eastern';
    switch (dateTime.getTimezoneOffset()) {
      default:
        zone = 'eastern'; // eastern|central|mountain|pacific
        break;
      case 240: // GMT -4:00
        zone = 'eastern';
        break;
      case 300: // GMT -5:00
        zone = dst ? 'central' : 'eastern';
        break;
      case 360: // GMT -6:00
        zone = dst ? 'mountain' : 'central';
        break;
      case 420: // GMT -7:00
        zone = dst ? 'pacific' : 'mountain';
        break;
      case 480: // GMT -8:00
        zone = 'pacific';
        break;
    }
    return zone;
  }

  /* Wait for a property to be defined */
  function checkDefined($context, $variable, $callback) {
    if ($context[$variable]) {
      $callback();
    } else {
      Object.defineProperty($context, $variable, {
        configurable: true,
        enumerable: true,
        writeable: true,
        get: function() {
          return this['_' + $variable];
        },
        set: function(val) {
          this['_' + $variable] = val;
          $callback();
        }
      });
    }
  }

  function escapeHtml(text) {
    return text.replace(/[\"'`&<>]/g, function(a) {
      return {
        '"': '&quot;',
        '\'': '&apos;',
        '`': '&grave;',
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
      }[a];
    });
  }

  const postGraphQLRequest = (graphQLEndpoint, authToken, query, variables = {}) => {
    return fetch(graphQLEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
        'x-platform': 'web',
        'x-issuer-type': 'Dalton'
      },
      body: JSON.stringify({
        query: query,
        variables: {
          ...variables
        },
      })
    }).then(response => {
      // debug.log('postGraphQLRequest response: ', response);
      return response.json();
    }).then(response => {
      // debug.log('postGraphQLRequest response.data: ', response.data);
      return response.data;
    }).catch(error => {
      // debug.error('postGraphQLRequest error: ', error);
    });
  };

  // icon symbol elements have uuid-hashed IDs to de-dup; starts with well-known form
  function getSvgIconSymbolId(svgName) {
    const baseId = `icon-${svgName}`;
    // look for an ID with appended MD5 hash, from sni-foundation-models/src/main/java/sni/models/SvgAggregator.java
    // if only... optional chaining (coming soon!)
    // let effId = $(`symbol[id|="${baseId}"]`)?.attr('id');
    let effId = $(`symbol[id|="${baseId}"]`) && $(`symbol[id|="${baseId}"]`).attr('id');
    // may need to load the SVG if it isn't present
    if (!effId) {
      effId = baseId;
      const containerId = `${baseId}-container`;
      // not already loaded (or loading (async))
      if (!document.getElementById(containerId)) {
        $('body').prepend(`<div id="${containerId}" style="display:none;"></div>`);
        let svgUrl = `/etc/designs/svg/${svgName}.svg`;
        // kludge for ID/crimefeed
        if (window.location.hostname === 'www.investigationdiscovery.com')
          svgUrl = `/crimefeed${svgUrl}`;
        fetch(svgUrl)
          .then( resp => resp.text() )
          .then( svgTxt => {
            $('#' + containerId).html(svgTxt);
            $('#' + containerId).children('svg').attr('id', effId);
          });
      }
    }
    return effId;
  }

  return {

    getVideoType(){
      const $body = $('body');
      let videoType;
      if ($body.hasClass('player-type--kdp')) {
        videoType = 'KDP';
      } else if ($body.addClass('player-type--mpx')) {
        videoType = 'MPX';
      } else {
        videoType = 'unknown';
      }
      return videoType;
    },

    isDebug() {
      return this.getUrlParam(window.location.href, 'debug') === 'true'
        || (check.supports('localStorage') && localStorage.getItem('debug') === 'true');
    },

    /*
    * memoize.js
    * by @philogb and @addyosmani
    * with further optimizations by @mathias
    * and @DmitryBaranovsk
    * perf tests: http://bit.ly/q3zpG3
    * Released under an MIT license.
    */
    memoize(fn) {
      return function() {
        var args = Array.prototype.slice.call(arguments),
            hash = '',
            i = args.length,
            currentArg = null;
        while (i--) {
          currentArg = args[i];
          hash += (currentArg === Object(currentArg)) ?
            JSON.stringify(currentArg) : currentArg;
          fn.memoize || (fn.memoize = {});
        }
        return (hash in fn.memoize) ? fn.memoize[hash] :
          fn.memoize[hash] = fn.apply(this, args);
      };
    },

    /**
     * This function goes into the element provided and pulls out either data attributes per setting or a JSON object of settings as override
     */
    getSettings(defaults, $element) {
      /** TODO: Get out of not a jquery element passed in */
      var options = {},
          settings = {};

      /** go through the defaults and see if for any of them we have individual data attributes specified */
      for (var key in defaults) {
        if ($element.data(key) !== undefined) {
          options[key] = $element.data(key);
        }
      }

      /** we have the concept of overrides, so if someone created an override vs single data attribute, go ahead and include that */
      var overrides = $element.data('moduleOverrides');
      if (overrides) {
        if (typeof overrides === 'string') {
          overrides = overrides.trim();
          overrides = overrides.length ? JSON.parse(overrides) : {};
        }
        options = $.extend(true, options, overrides);
      }

      /** return the defaults overriden with the passed in options as settings */
      settings = $.extend(true, {}, defaults, options);
      return settings;
    },

    /**
     * This will register your function as a jQuery plugin
     * @constructor
     * @param {string} fnName - The named function.
     * @param {object} fnRef - A reference to the function.
     */
    registerjQueryPlugin(fnName, FnRef) {

      // PLUGIN DEFINITION
      // =========================

      var old = $.fn[fnName];

      $.fn[fnName] = function(option) {
        return this.each(function() {
          var $this = $(this);
          var data = $this.data('sni.' + fnName);
          var options = typeof option === 'object' && option;

          if (!data && option === 'destroy') return;
          if (!data) $this.data('sni.' + fnName, (data = new FnRef(this, options)));
          if (typeof option === 'string') data[option]();
        });
      };

      $.fn[fnName].Constructor = FnRef;

      // NO CONFLICT
      // ===================

      $.fn[fnName].noConflict = function() {
        $.fn[fnName] = old;
        return this;
      };
    },

    /**
     * Get a URL parameter value
     * @param  {string} param URL
     * @param  {string} param Parameter name
     * @return {string}       Parameter value
     */
    getUrlParam(url, param) {
      param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + param + '=([^&#]*)'),
          results = regex.exec(url);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    /**
     * Determine if an element is within the viewport. Uses a 'visibility' parameter to determine if the entire element is
     * in view (full) or if any part of the element is in view (partial).
     * @param  {DOMElement}  el           DOM element to test
     * @param  {string}      visibility  'full' or 'partial'
     * @return {Boolean}
     */
    isInViewport(el, visibility, offset) {
      if (!el) return false;    // el is required
      var rect = el.getBoundingClientRect();

      if (rect.top + rect.left + rect.bottom + rect.right === 0) return false; // bail on 0 size rects

      let top = rect.top;

      if (offset) {
        /** Shift the image up when an offset is set */
        if (top < offset) top = 0;
      }

      /** Give 'visibility' a default if it's not provided */
      if (!visibility) {
        visibility = 'full';
      }

      /** Return true if the entire element is in the viewport */
      if (visibility === 'full') {
        return (
          top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= $(window).height() &&
          rect.right <= $(window).width()
        );
      }

      /** Return true if any part of the element is in the viewport */
      if (visibility === 'partial') {
        return (
          top <= $(window).height() &&
          rect.bottom >= 0 &&
          rect.right >= 0
        );
      }


    },

    /*
      Calculate how much of an element is visible on the viewport
      */
    percentVisible(element) {
      if (!(element && element.getBoundingClientRect)) return 0;  // nothing to see here
      let rect = element.getBoundingClientRect();
      let { height, top, bottom } = rect;
      let finalHeight;
      let windowHeight = window.innerHeight;

      if (top > windowHeight || bottom < 0) { // Not in view
        finalHeight = 0;
      } else if (top >= 0 && bottom <= windowHeight) {  //   In full view
        finalHeight = height;
      } else {  // partially in view
        let calcTop = top < 0 ? 0 : top;
        let calcBot = bottom < windowHeight ? bottom : windowHeight;
        finalHeight = calcBot - calcTop;
      }

      return finalHeight / height * 100;

    },

    getIdFromSelector(selector) {
      return selector.split(' #').pop().replace(/#/g, '').trim();
    },

    setCounter(amount) {
      counter = amount;
    },

    getCounter() {
      return counter;
    },

    /**
     * Convert escaped quotes before JSON parse is called
     */
    fixQuotes(text) {
      return text.replace(/\\'/gi, '\'');
    },

    escapeHtml,

    getElementJSON($element) {
      let val = {};
      if ($element) {
        let $JSON = $element.find('script');
        if ($JSON.length > 0) {
          try {
            let content = $JSON[0].innerHTML;
            let unquote = this.fixQuotes(content);
            let parsedContent = JSON.parse(unquote);
            val = parsedContent;
          } catch (e) {
            //   could not retrieve JSON
          }
        }
      }
      return val;
    },

    ajaxLoadScript: (scriptUrl) => {
      $.getScript(scriptUrl)
        .done((script, textStatus) => {
          $('div.log').text('ajaxLoadScript()loaded successfully! It was a ' + textStatus);
        })
        .fail((jqxhr, settings, exception) => {
          $('div.log').text('ajaxLoadScript() source error!');
        });
    },

    buildUrlWithSelector: (link, isMobile = false, selector, appendParams = '') => {
      const extensionPattern = /\.?(beta\.?)?(mobile\.?)?(html)?$/;
      let originalUrl = link.href.split('?')[0].split('#')[0].replace(/\/+$/, '');
      // If we're on author environment, add back in the .html so the requests work
      selector = link.href.indexOf('author.') !== -1 || link.href.indexOf('publish.') !== -1 
        ? selector + (isMobile? '.mobile' : '')  + '.html' : selector;
      const newUrl = `${originalUrl.replace(extensionPattern, '')}.${selector}${appendParams}`;

      return newUrl;
    },

    getDynamicContent(url, $element, target, handler, failure, final){
      if (!url) return;
      function replacer(content){
        if (!($element && content)) return;
        let $html = $(content).find(target);
        if ($html.length) {
          $element[0].innerHTML = '';
          $element.append($html.children());
        }
      }
      $.get(url).done(replacer).then(handler).fail(failure).always(final);
    },

    addJavaScriptCssClass: () => {
      $('html').addClass('js core-js');
    },

    getRandomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    convertNumberToIntegerThenString(num){
      if (typeof num !== 'number') {
        return '0';
      } else {
        const int = parseInt(num);
        const intString = int.toString();
        return intString;
      }
    },

    getMainHostname,

    getProdUrl,

    getModuleConfig: application.getModuleConfig,

    bindClickOutside,

    unbindClickOutside,

    deepMerge,

    stdTimezoneOffset,

    isDaylightSavings,

    getZone,

    toTitleCase,

    throttle,

    debounce,

    checkDefined,

    postGraphQLRequest,

    getSvgIconSymbolId,

  };

});
